export default (dateString, time) => {
  const date = new Date(dateString);
  const now = new Date();
  const timeSplits = time.split(':');
  const dateTime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), timeSplits[0], timeSplits[1], 0, 0);

  return dateTime > now;
};
